module.exports = __webpack_public_path__ + "img/1546344039.24a978da.jpg";